import { render, staticRenderFns } from "./WorkoutsPage.vue?vue&type=template&id=755cad50&"
import script from "./WorkoutsPage.vue?vue&type=script&lang=js&"
export * from "./WorkoutsPage.vue?vue&type=script&lang=js&"
import style0 from "./WorkoutsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports